import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: { dark: '#1a171b', main: '#3e3d40', light: '#87888a' },
    secondary: { main: '#ff4338' },
    text: {
      primary: '#1a171b',
    },
  },
});

export default theme;
